import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/siteData";

export const WhatsAppButton = () => (
  <motion.a
    href={COMPANY.whatsapp}
    target="_blank"
    rel="noreferrer"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.2, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
    className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-teal-400 text-[#0B132B] shadow-[0_8px_30px_rgba(20,184,166,0.45)]"
    aria-label="Chat on WhatsApp"
    data-testid="whatsapp-float-button"
  >
    <MessageCircle className="w-6 h-6" />
  </motion.a>
);

export default WhatsAppButton;
